import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Palette } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { DesignSystemPage } from "./pages/DesignSystemPage";

export const sandboxModule: FeatureModule = {
  key: "sandbox",
  nav: {
    label: "Design System",
    icon: Palette,
    to: "/design-system",
    requires: "sandbox.read",
    order: 120,
    group: "Tools",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/design-system",
      component: guarded("sandbox.read", DesignSystemPage),
    }),
  ] as unknown as AnyRoute[],
};
